import { Component, EventEmitter, Input, Output, inject } from '@angular/core';
import { ImageUtils } from '../../../../utils/image.utils';
import { CartUtils } from '../../../../utils/cart.utils';
import { UiUtils } from '../../../../utils/ui.utils';
import { CustomerFacade } from '../../../../facades/customer.facade';
import { CatalogActions } from '../../../../actions';
import { Store } from '@ngrx/store';
import { State } from '../../../../reducers';
import { AppUtils } from '../../../../utils/app.utils';
import { ImagePreset } from '../../../../models/image.models';

@Component({
  selector: 'app-other-cart',
  templateUrl: './other-cart.component.html',
  styleUrls: ['./other-cart.component.scss'],
  standalone: false,
})
export class OtherCartComponent {
  private customerFacade: CustomerFacade = inject(CustomerFacade);
  private store: Store<State> = inject<Store<State>>(Store);


  isSapStore: boolean = AppUtils.isSapStore();

  @Input() loadingCart!: boolean;
  @Input() cart: any;
  @Input() cartImages!: any[];

  @Output() switchCartEmit: EventEmitter<{cartId: string, redirect: boolean}> = new EventEmitter<{cartId: string, redirect: boolean}>();
  @Output() deleteCartEmit: EventEmitter<{cartId: string, totalItemsQuantity: number}> = new EventEmitter<{cartId: string, totalItemsQuantity: number}>();

  cartName: typeof CartUtils.getCartName = CartUtils.getCartName;
  singularOrPlural: typeof UiUtils.singularOrPlural = UiUtils.singularOrPlural;

  getImageForCart(itemId: string): string {
    return ImageUtils.getProductImageUrl(
      this.cartImages.find(imageSet => imageSet.id === itemId), ImagePreset.Small);
  }

  switchCart(cartId: string, redirect?: true): void {
    this.customerFacade.clearPointOfContact();
    this.customerFacade.clearCustomCustomerShipToAddress();
    this.store.dispatch(CatalogActions.setCachedProductsToBeReloaded());
    this.switchCartEmit.emit({cartId, redirect: redirect ?? false});
  }

  deleteCart(cartId: string, totalItemsQuantity: number): void {
    this.deleteCartEmit.emit({cartId, totalItemsQuantity});
  }
}
